<app-standard-modal
  :open="true"
  title="Select Customer"
  title-id="select-customer-modal-title"
  size="small"
  :scrolling="false"
  append-to-body
  @close="$emit('back')"
>
  <div class="customer-modal-body">
    <!-- Search mode -->
    <template v-if="mode === 'search'">
      <div class="field settings customer-modal-field">
        <app-field-label>Customer Name</app-field-label>
        <contact-select
          :model-value="contact"
          @update:model-value="onContactInput"
          :options="contacts"
          :loading="contactSearchLoading"
          placeholder="Search name, email, or phone"
          @search="onContactSearch"
        />
      </div>

      <button
        type="button"
        class="customer-modal-create-link"
        @click="enterCreateMode"
      >Create New Customer</button>

      <!-- SM8 job selector — only when selected contact is linked to a SM8 client -->
      <div v-if="contact && contact.service_m8_uuid" class="customer-modal-sm8">
        <app-field-label>
          <span class="customer-modal-sm8-label">
            <img src="../../../../assets/img/icn_servicem8.png" alt="" class="customer-modal-sm8-icon" aria-hidden="true">
            ServiceM8 Job Number
          </span>
        </app-field-label>
        <app-select
          :defaultLabel="serviceM8Loading ? 'Loading jobs…' : 'Select a ServiceM8 job'"
          :items="sm8JobSelectItems"
          :value="serviceM8JobUuid"
          :disabled="serviceM8Loading"
          @selected="onSm8JobSelected"
        />
        <p class="customer-modal-sm8-help">
          This customer has a matching ServiceM8 record. Select a job number to sync your quote to that job.
        </p>
      </div>
    </template>

    <!-- Create mode -->
    <template v-else>
      <app-field-error v-if="createFormError" :message="createFormError" />

      <div class="field settings customer-modal-field" :class="{ error: !!createErrors.company }">
        <app-field-label>Customer Name *</app-field-label>
        <app-text-input
          :model-value="createForm.company"
          placeholder="Enter person or company name"
          :error="!!createErrors.company"
          @update:model-value="onCreateField('company', $event)"
        />
        <app-field-error :message="createErrors.company" />
      </div>

      <div class="field settings customer-modal-field" :class="{ error: !!createErrors.email }">
        <app-field-label>Email Address *</app-field-label>
        <app-text-input
          type="email"
          :model-value="createForm.email"
          placeholder="Enter email address"
          :error="!!createErrors.email"
          @update:model-value="onCreateField('email', $event)"
        />
        <app-field-error :message="createErrors.email" />
      </div>

      <div class="two fields customer-modal-field">
        <div class="field settings" :class="{ error: !!createErrors.phone }">
          <app-field-label>Phone Number</app-field-label>
          <app-text-input
            :model-value="createForm.phone"
            placeholder="Enter phone number"
            :error="!!createErrors.phone"
            @update:model-value="onCreateField('phone', $event)"
          />
          <app-field-error :message="createErrors.phone" />
        </div>
        <div class="field settings" :class="{ error: !!createErrors.mobile }">
          <app-field-label>Mobile Number</app-field-label>
          <app-text-input
            :model-value="createForm.mobile"
            placeholder="Enter mobile number"
            :error="!!createErrors.mobile"
            @update:model-value="onCreateField('mobile', $event)"
          />
          <app-field-error :message="createErrors.mobile" />
        </div>
      </div>
    </template>
  </div>

  <template #footer>
    <template v-if="mode === 'search'">
      <div
        class="ui basic button smardie-btn-secondary"
        :class="{ disabled: submitting }"
        @click="!submitting && $emit('back')"
      >Cancel</div>
      <div
        class="ui right primary button"
        :class="{ loading: submitting, disabled: submitting || !(contact && contact.id) }"
        @click="start"
      >{{ submitLabel || (duplicate ? 'Duplicate Quote' : 'Start Quote') }}</div>
    </template>
    <template v-else>
      <div
        class="ui basic button smardie-btn-secondary"
        :class="{ disabled: createSaving }"
        @click="!createSaving && exitCreateMode()"
      >Cancel</div>
      <div
        class="ui right primary button"
        :class="{ loading: createSaving, disabled: createSaving }"
        @click="saveNewCustomer"
      >Save Customer</div>
    </template>
  </template>
</app-standard-modal>
